<template>
  <div id="settings-team-definition">
    <b-card footer-tag="footer">

      <rc-overlay :show="loading">
        <b-card-text>
          <validation-observer ref="editTeamDefinitionValidation">
            <form
              id="editTeamDefinitionForm"
              @submit.prevent
            >

              <b-row>
                <b-col
                  cols="12"
                  class="pb-1"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('conf.settings.team-definition.form.code')"
                    rules="required|alpha-dash|min:3|max:10"
                  >
                    <label for="team-definition">
                      {{ $t('conf.settings.team-definition.form.code') }}
                    </label>
                    <b-form-input
                      id="team-definition"
                      v-model="teamDefinitionForm.code"
                      type="text"
                      minlength="3"
                      maxlength="10"
                      :placeholder="$t('conf.settings.team-definition.form.code')"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col
                  cols="12"
                  class="pb-1"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('conf.settings.team-definition.form.phone')"
                    rules="digits:9"
                  >
                    <label for="phoneNumber">
                      {{ $t('conf.settings.team-definition.form.phone') }}
                    </label>
                    <b-form-input
                      id="phoneNumber"
                      v-model="teamDefinitionForm.phoneNumber"
                      type="number"
                      minlength="9"
                      maxlength="9"
                      :placeholder="$t('conf.settings.team-definition.form.phone')"
                      autocomplete="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="teamDefinitionForm.allowDriverAsParamedic"
                      :disabled="teamDefinitionForm.driverOnly"
                    >
                      {{ $t('conf.settings.team-definition.form.allow-driver-as-paramedic') }}
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      {{ $t('conf.settings.team-definition.form.allow-driver-as-paramedic-help') }}
                    </small>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox
                      v-model="teamDefinitionForm.driverOnly"
                      @change="handleDriverOnlyToggle"
                    >
                      {{ $t('conf.settings.team-definition.form.driver-only') }}
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      {{ $t('conf.settings.team-definition.form.driver-only-help') }}
                    </small>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox v-model="teamDefinitionForm.displayInPlanner">
                      {{ $t('conf.settings.team-definition.form.display-in-planner') }}
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      {{ $t('conf.settings.team-definition.form.display-in-planner-help') }}
                    </small>
                  </b-form-group>
                </b-col>

                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox v-model="teamDefinitionForm.acceptsFirstAvailableOrders">
                      {{ $t('conf.settings.team-definition.form.accepts-first-available-orders') }}
                    </b-form-checkbox>
                    <small class="form-text text-muted">
                      {{ $t('conf.settings.team-definition.form.accepts-first-available-orders-help') }}
                    </small>
                  </b-form-group>
                </b-col>
              </b-row>

            </form>
          </validation-observer>
        </b-card-text>
      </rc-overlay>

      <template #footer>

        <div class="text-right">
          <b-button
            class="mr-1"
            variant="outline-warning"
            @click="$router.back()"
          >
            {{ $t('shared.button.cancel') }}
          </b-button>

          <b-button
            variant="primary"
            :disabled="loading"
            @click="submitForm"
          >
            {{ $t('shared.button.submit') }}
          </b-button>
        </div>

      </template>

    </b-card>
  </div>
</template>

<script>
import { cloneNested, parseRequestError } from '@/helpers/helpers'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RcOverlay from '@/layouts/components/rc/RcOverlay.vue'
import {
  BButton, BCard, BCardText, BCol, BFormInput, BRow,
} from 'bootstrap-vue'

export default {
  components: {
    BFormInput,
    BCard,
    BCardText,
    BButton,
    RcOverlay,
    BRow,
    BCol,

    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      teamDefinitionForm: cloneNested(this.$store.state.settings.emptyTeamDefinition),
    }
  },
  created() {
    this.initTeamDefinitionData()
  },
  beforeDestroy() {
    this.$store.commit('settings/CLEAR_TEAM_DEFINITION_DATA')
  },
  methods: {
    handleDriverOnlyToggle(value) {
      if (value) {
        this.$set(this.teamDefinitionForm, 'allowDriverAsParamedic', false)
      }
    },
    initTeamDefinitionData() {
      this.loading = true
      this.$store.dispatch('settings/fetchTeamDefinitionData', this.$route.params.id)
        .then(() => {
          this.teamDefinitionForm = cloneNested(this.$store.getters['settings/getTeamDefinitionData'])
          this.loading = false
        })
        .catch(err => parseRequestError(err))
    },
    submitForm() {
      this.$refs.editTeamDefinitionValidation.validate()
        .then(valid => {
          if (!valid) {
            return false
          }

          this.loading = true
          const teamDefinitionData = cloneNested(this.teamDefinitionForm)

          const payload = {
            id: teamDefinitionData.id,
            data: teamDefinitionData,
          }
          this.$store.dispatch('settings/updateTeamDefinition', payload)
            .then(() => {
              window.toast.notify.success(this.$t('conf.settings.team-definition.notify.edit.success_title'))
            })
            .catch(err => {
              parseRequestError(err)
              this.initTeamDefinitionData()
            })
            .finally(() => {
              this.loading = false
            })

          return true
        })
    },
  },
}
</script>
